"use strict";
export var Urgency = /* @__PURE__ */ ((Urgency2) => {
  Urgency2["NORMAL"] = "normal";
  Urgency2["FAST"] = "fast";
  Urgency2["URGENT"] = "urgent";
  return Urgency2;
})(Urgency || {});
